<template>
  <div>
    <a :href="params.data.url" target="_blank">{{params.data.url}}</a>
  </div>
</template>

<script>
export default {};
</script>